module.exports = __webpack_public_path__ + "img/proyecto_home2.b497c679.png";